<template>
<div class="panel bgPanel mt1x pb2x emptyToken_EE textCut_EE" :class="fromChild=='detail'?'h21x':''">
    <div class="title title-bg">
        <span :title="getLanguageStr('word1747','用电实时')">{{getLanguageStr("word1747","用电实时")}}</span>
        <!-- <a class="fR fs08x" @click="$emit('realData')">{{$t('',['点击查看详情'])}}</a> -->
    </div>
    <loading v-show="isLoading"></loading>
    <div class="pl2x pr2x">
        <div class="mt1x dpIB_E vaT_E pb2x" :class="fromChild=='detail'?'bdSub-bottom':''">
            <div class="taC mr1x">
                <div class="icoSys h3x w3x" :class="{bgPrimary:stationInfo.usePower,bgLight:!stationInfo.usePower}">
                    <svg :class="{fWhite:stationInfo.usePower,fSub:!stationInfo.usePower}">
                        <use xlink:href="#ico-house-useElectricity"></use>
                    </svg>
                </div>
                <span class="mt05x dpIB" :title="getLanguageStr('word561','用电')">{{getLanguageStr('word561','用电')}}</span>
            </div>
            <ul class="fL_E clearfix pl2x" :class="fromChild=='detail'?'mr3x_E':'ml4x mr10x_E'">
                <li>
                    <div class="mb1x" :title="$t('word977',['用电功率'])">{{$t("word977",["用电功率"])}}</div>
                    <div class="cMain">
                        <span :title="convertData(stationInfo.usePower,2,'','W')[0]">
                            <span class="fs14x">{{convertData(stationInfo.usePower,2,"","W")[1]}}</span>
                            {{convertData(stationInfo.usePower,2,"","W")[2]}}
                        </span>
                    </div>
                </li>
                <li v-if="fromChild=='childDetail'">
                	<div class="mb1x" :title="$t('word527',['当日用电量'])">{{$t("word527",["当日用电量"])}}</div>
                    <div class="cMain">
                        <span :title="convertData(stationInfo.useValue,2,'k','Wh')[0]">
                            <span class="fs14x">{{convertData(stationInfo.useValue,2,'k','Wh')[1]}}</span>
                            {{convertData(stationInfo.useValue,2,'k','Wh')[2]}}
                        </span>
                    </div>
                </li>
                <li v-if="fromChild=='childDetail'">
                	<div class="mb1x" :title="$t('word528',['当月用电量'])">{{$t("word528",["当月用电量"])}}</div>
                    <div class="cMain">
                        <span :title="convertData(stationInfo.useMonth,2,'k','Wh','','W')[0]">
                            <span class="fs14x">{{convertData(stationInfo.useMonth,2,'k','Wh')[1]}}</span>
                            {{convertData(stationInfo.useMonth,2,'k','Wh')[2]}}
                        </span>
                    </div>
                </li>
                 <li v-if="fromChild=='childDetail'">
                	<div class="mb1x" :title="$t('word529',['当年用电量'])">{{$t("word529",["当年用电量"])}}</div>
                    <div class="cMain">
                        <span :title="convertData(stationInfo.useYear,2,'k','Wh','','W')[0]">
                            <span class="fs14x">{{convertData(stationInfo.useYear,2,'k','Wh')[1]}}</span>
                            {{convertData(stationInfo.useYear,2,'k','Wh')[2]}}
                        </span>
                    </div>
                </li>
                 <li v-if="fromChild=='childDetail'">
                	<div class="mb1x" :title="$t('word526',['累计用电量'])">{{$t("word526",["累计用电量"])}}</div>
                    <div class="cMain">
                        <span :title="convertData(stationInfo.useUploadTotal,2,'k','Wh','','W')[0]">
                            <span class="fs14x">{{convertData(stationInfo.useUploadTotal,2,'k','Wh')[1]}}</span>
                            {{convertData(stationInfo.useUploadTotal,2,'k','Wh')[2]}}
                        </span>
                    </div>
                </li>
                <!-- <li>
                    <div class="mb1x" :title="getLanguageStr('word1727','当日满发小时')">{{getLanguageStr("word1727","当日满发小时")}}</div>
                    <div :title="floatFix(stationInfo.dailyfullHour,2,' h')">
                        <span class="fs14x">{{floatFix(stationInfo.dailyfullHour,2)}}</span>
                        <span v-if="stationInfo.dailyfullHour !=null">h</span>
                    </div>
                </li> -->
            </ul>
        </div>
        <div class="pt2x pb2x tableSys vaM_E" v-if="fromChild=='detail'">
            <div class="w40pct bdSub-right">
                <div class="dpIB">
                    <div class="mb2x" :title="$t('word527',['当日用电量'])">{{$t("word527",["当日用电量"])}}</div>
                    <div class="cMain" :title="convertData(stationInfo.useValue,2,'k','Wh')[0]">
                        <span class="fs16x">{{convertData(stationInfo.useValue,2,"k","Wh")[1]}}</span>
                        {{convertData(stationInfo.useValue,2,"k","Wh")[2]}}
                    </div>
                </div>
            </div>
            <div class="pl3x lh13">
                <div class="mb1x"><span class="mr2x" :title="$t('word528',['当月用电量'])">{{$t("word528",["当月用电量"])}}</span><span :title="convertData(stationInfo.useMonth,2,'k','Wh')[0]">{{convertData(stationInfo.useMonth,2,"k","Wh")[0]}}</span></div>
                <div class="mb1x"><span class="mr2x" :title="$t('word529',['当年用电量'])">{{$t("word529",["当年用电量"])}}</span><span :title="convertData(stationInfo.useYear,2,'k','Wh')[0]">{{convertData(stationInfo.useYear,2,"k","Wh")[0]}}</span></div>
                <div><span class="mr2x" :title="$t('word526',['累计用电量'])">{{$t("word526",["累计用电量"])}}</span><span :title="convertData(stationInfo.useUploadTotal,2,'k','Wh')[0]">{{convertData(stationInfo.useUploadTotal,2,"k","Wh")[0]}}</span></div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Loading from '@/components/common/ui/Loading'
import * as equipmentApi from '@/api/maintain/plant/list'
import * as lib from "@/util/lib.js"
import {getLanguageStr} from "@/util/language.js"
export default {
    name:'GeneratePower',
    components:{Loading},
    props: {
	    fromChild: {
	      type: String,
	      default: 'detail'
	    }
  	},
    data(){
        return{
            isLoading:false,
            stationInfo:{},
        }
    },
    methods:{
        getLanguageStr,
        getTypeText:lib.getTypeText,
        floatFix:lib.floatFix,
        convertData:lib.convertData,
        show(data){
            if(data.stationInfo){
                this.stationInfo=data.stationInfo
                setTimeout(()=>{
                    this.isLoading=false
                },500)
            }else{
                this._getList(data.stationId)
                
            }
        },
        _getList(id){
            this.isLoading=true
            equipmentApi.StationInfo(id).then(res=>{
                this.isLoading=false
                this.stationInfo=res
            },error=>{
                this.isLoading=false
                 !_.isEmpty(error) && this.$notify(error)
            })
        }
      
    }
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
</style>




// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/UsePower.vue